module.exports = __webpack_public_path__ + "static/media/foto3.d6ec619a.jpeg";